import React, { useState } from 'react';
import { CalendarIcon, ClockIcon, MapPinIcon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
const DutyAllotmentScreen: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'upcoming' | 'completed'>('upcoming');
  const upcomingDuties = [{
    id: 1,
    title: 'Masjid Security',
    location: 'Main Entrance, Burhani Masjid',
    date: 'June 15, 2023',
    time: '7:00 PM - 9:00 PM',
    status: 'upcoming'
  }, {
    id: 2,
    title: 'Event Security',
    location: 'Community Hall',
    date: 'June 20, 2023',
    time: '5:00 PM - 8:00 PM',
    status: 'upcoming'
  }, {
    id: 3,
    title: 'Parking Management',
    location: 'Masjid Parking Lot',
    date: 'June 25, 2023',
    time: '12:00 PM - 2:00 PM',
    status: 'upcoming'
  }];
  const completedDuties = [{
    id: 4,
    title: 'Masjid Security',
    location: 'Side Entrance, Burhani Masjid',
    date: 'June 10, 2023',
    time: '7:00 PM - 9:00 PM',
    status: 'completed'
  }, {
    id: 5,
    title: 'Event Security',
    location: 'Community Hall',
    date: 'June 5, 2023',
    time: '5:00 PM - 8:00 PM',
    status: 'completed'
  }, {
    id: 6,
    title: 'Traffic Management',
    location: 'Main Road Junction',
    date: 'May 30, 2023',
    time: '6:00 PM - 8:00 PM',
    status: 'completed'
  }];
  const duties = activeTab === 'upcoming' ? upcomingDuties : completedDuties;
  return <div className="px-4 py-6" data-id="element-67">
      <div className="mb-6" data-id="element-68">
        <h1 className="text-xl font-bold text-gray-900" data-id="element-69">Duty Allotments</h1>
        <p className="text-gray-600 text-sm" data-id="element-70">Manage your assigned duties</p>
      </div>
      {/* Tab Navigation */}
      <div className="flex mb-6 border-b border-gray-200" data-id="element-71">
        <button className={`flex-1 py-3 text-center font-medium ${activeTab === 'upcoming' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`} onClick={() => setActiveTab('upcoming')} data-id="element-72">
          Upcoming
        </button>
        <button className={`flex-1 py-3 text-center font-medium ${activeTab === 'completed' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`} onClick={() => setActiveTab('completed')} data-id="element-73">
          Completed
        </button>
      </div>
      {/* Duties List */}
      <div className="space-y-4" data-id="element-74">
        {duties.length > 0 ? duties.map(duty => <div key={duty.id} className="bg-white rounded-lg shadow-sm p-4" data-id="element-75">
              <div className="flex items-start justify-between mb-3" data-id="element-76">
                <div data-id="element-77">
                  <h3 className="font-semibold text-gray-900" data-id="element-78">{duty.title}</h3>
                  <p className="text-sm text-gray-600" data-id="element-79">{duty.location}</p>
                </div>
                {duty.status === 'upcoming' ? <div className="px-3 py-1 bg-blue-100 text-blue-800 text-xs rounded-full" data-id="element-80">
                    Upcoming
                  </div> : <div className="px-3 py-1 bg-green-100 text-green-800 text-xs rounded-full" data-id="element-81">
                    Completed
                  </div>}
              </div>
              <div className="flex items-center text-sm text-gray-700 mb-2" data-id="element-82">
                <CalendarIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-83" />
                <span data-id="element-84">{duty.date}</span>
              </div>
              <div className="flex items-center text-sm text-gray-700 mb-2" data-id="element-85">
                <ClockIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-86" />
                <span data-id="element-87">{duty.time}</span>
              </div>
              <div className="flex items-center text-sm text-gray-700" data-id="element-88">
                <MapPinIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-89" />
                <span data-id="element-90">{duty.location}</span>
              </div>
              {duty.status === 'upcoming' && <div className="mt-4 flex justify-between" data-id="element-91">
                  <button className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium" data-id="element-92">
                    Confirm Attendance
                  </button>
                  <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md text-sm font-medium" data-id="element-93">
                    Request Change
                  </button>
                </div>}
              {duty.status === 'completed' && <div className="mt-4 flex items-center text-green-600" data-id="element-94">
                  <CheckCircleIcon className="w-5 h-5 mr-1" data-id="element-95" />
                  <span className="text-sm font-medium" data-id="element-96">Duty Completed</span>
                </div>}
            </div>) : <div className="bg-gray-50 rounded-lg p-8 text-center" data-id="element-97">
            <AlertCircleIcon className="w-12 h-12 text-gray-400 mx-auto mb-4" data-id="element-98" />
            <h3 className="text-gray-700 font-medium mb-1" data-id="element-99">No Duties Found</h3>
            <p className="text-gray-500 text-sm" data-id="element-100">
              You don't have any {activeTab} duties at the moment.
            </p>
          </div>}
      </div>
    </div>;
};
export default DutyAllotmentScreen;